import React from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

type Props = {
  oddsOptions: { label: string; value: string }[];
  updateOdds: (selectedValue: string) => void;
  selectedOdds: string;
  disabled: boolean;
};

const OddsSelector: React.FC<Props> = ({
  oddsOptions,
  updateOdds,
  selectedOdds,
  disabled,
}) => {
  return (
    <div className="global-event-navigation--odds">
      <Dropdown
        options={oddsOptions}
        className={`navigation-odds__dropdown ${disabled ? "disabled" : ""}`}
        onChange={e => updateOdds(e.value)}
        value={selectedOdds}
      />
    </div>
  );
};

export default OddsSelector;
